<template>
	<ClientTeleport>
		<div
			class="fixed inset-0 z-popup isolate flex justify-end"
			:class="{'pointer-events-none': !open}"
			tabindex="0"
		>
			<Transition name="fade">
				<div v-if="open" class="absolute inset-0 z-below bg-black/20" />
			</Transition>
			<Transition
				enter-from-class="max-sm:translate-y-full sm:translate-x-full"
				leave-to-class="max-sm:translate-y-full sm:translate-x-full"
			>
				<div v-if="open" ref="containerRef" class="relative transition-transform bg-background-primary max-sm:mt-24 max-sm:w-full max-sm:rounded-t-2.5xl">
					<NuxtImg src="/images/slideout-illustration.svg" class="absolute top-0 left-0 w-32 max-sm:hidden" alt="" />
					<button
						type="button"
						class="p-2 absolute top-2 right-2 hover:bg-button-secondary-surface-hover rounded-full transition ease"
						aria-label="Zavřít"
						@click="closeSlideout"
					>
						<NuxtIcon name="x" filled class="text-2xl text-icon-primary" />
					</button>
					<slot />
				</div>
			</Transition>
		</div>
	</ClientTeleport>
</template>

<script setup lang="ts">
	import {useFocusTrap} from '@vueuse/integrations/useFocusTrap';
	import {onClickOutside, onKeyStroke} from '@vueuse/core';

	type Props = {
		open: boolean;
	};

	type Emits = {
		(e: 'update:open', value: boolean): void;
	};

	const props = defineProps<Props>();
	const emit = defineEmits<Emits>();

	const containerRef = ref(null);
	const {activate: activateFocusTrap, deactivate: deactivateFocusTrap} = useFocusTrap(containerRef);

	onClickOutside(containerRef, closeSlideout);
	onKeyStroke('Escape', closeSlideout);

	const isLocked = useBodyScrollLock();

	function closeSlideout() {
		emit('update:open', false);
	}

	watch(() => props.open, async (newValue) => {
		isLocked.value = newValue;
		await nextTick();
		newValue ? activateFocusTrap() : deactivateFocusTrap();
	}, {immediate: true});
</script>
